(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sm-bis"] && !Shopify.designMode) return;
  try {
    // Eén gedelegeerde handler voor elk BIS-formulier op de pagina, nu en later.
  (function () {
    if (window.__smBis) return;
    window.__smBis = true;

    var REVISIE = '2026-01-15';

    function melden(form, tekst, stand) {
      var el = form.querySelector('.bis-melding');
      if (!el) return;
      el.setAttribute('data-stand', stand);
      el.textContent = tekst;
    }

    function post(pad, key, body) {
      return fetch('https://a.klaviyo.com/client/' + pad + '/?company_id=' + encodeURIComponent(key), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: REVISIE },
        body: JSON.stringify(body)
      });
    }

    document.addEventListener('submit', function (e) {
      var form = e.target.closest ? e.target.closest('form[data-bis]') : null;
      if (!form) return;
      e.preventDefault();

      var veld = form.querySelector('.bis-mail');
      var knop = form.querySelector('.bis-knop');
      var mail = veld ? veld.value.trim() : '';
      var key = form.getAttribute('data-bis-key');
      var variant = form.getAttribute('data-bis-variant');

      // Dezelfde toets die Klaviyo zelf doet. `type="email"` vangt het meeste al
      // af, maar novalidate staat aan omdat de browsermelding niet te stylen is.
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail)) {
        if (veld) {
          veld.setAttribute('aria-invalid', 'true');
          veld.focus();
        }
        melden(form, form.getAttribute('data-bis-t-ongeldig') || 'Vul een geldig e-mailadres in.', 'fout');
        return;
      }
      if (veld) veld.removeAttribute('aria-invalid');
      if (knop) knop.disabled = true;

      post('back-in-stock-subscriptions', key, {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: { data: { type: 'profile', attributes: { email: mail } } }
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variant } }
          }
        }
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Klaviyo ' + res.status);

          var rij = form.querySelector('.bis-rij');
          var uitleg = form.querySelector('.bis-uitleg');
          melden(form, form.getAttribute('data-bis-t-klaar') || 'Gelukt — je krijgt bericht zodra dit weer op voorraad is.', 'klaar');

          // Focus eerst verplaatsen, dán pas de rij weghalen. De focus stond op de
          // knop of het veld en die zitten allebei ín die rij; verdwijnt hij eerst,
          // dan valt de focus terug naar <body> en verliest een toetsenbord- of
          // schermlezergebruiker zijn plek precies op het moment dat de melding
          // voorgelezen moet worden.
          var melding = form.querySelector('.bis-melding');
          if (melding) melding.focus();
          if (rij) rij.hidden = true;
          if (uitleg) uitleg.hidden = true;
        })
        .catch(function () {
          melden(form, form.getAttribute('data-bis-t-fout') || 'Er ging iets mis. Probeer het zo nog eens.', 'fout');
          if (knop) knop.disabled = false;
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sm-bundel-inhoud"] && !Shopify.designMode) return;
  try {
    // Eén gedelegeerde luisteraar voor de hele pagina, en scoping op de
  // dichtstbijzijnde `.sm-bundel`: het snippet kan meer dan één keer op een
  // pagina staan, en dan hebben twee lijsten dezelfde paneelnummers.
  document.addEventListener('click', (e) => {
    const knop = e.target.closest('[data-sm-bundel-open]')
    if (!knop) return
    const blok = knop.closest('.sm-bundel')
    const dialog = blok && blok.querySelector('[data-sm-bundel-dialog]')
    if (!dialog) return

    const nr = knop.getAttribute('data-sm-bundel-open')
    let doel = null
    dialog.querySelectorAll('[data-sm-bundel-paneel]').forEach((p) => {
      const op = p.getAttribute('data-sm-bundel-paneel') === nr
      p.classList.toggle('is-op', op)
      if (op) doel = p
    })
    if (!doel) return

    // `showModal` en niet `show`: dat levert de backdrop, het focusslot en
    // Escape zonder eigen code. Dubbel openen gooit een InvalidStateError.
    if (!dialog.open) dialog.showModal()
    dialog.scrollTop = 0
  })

  // Klik naast het paneel sluit. Een <dialog> vangt kliks op de backdrop op
  // het dialog-element zelf, dus de toets is "zat de klik buiten de doos".
  document.addEventListener('click', (e) => {
    const dialog = e.target.closest('[data-sm-bundel-dialog]')
    if (!dialog || e.target !== dialog) return
    const r = dialog.getBoundingClientRect()
    const buiten =
      e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom
    if (buiten) dialog.close()
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sm-eerste-bezoek"] && !Shopify.designMode) return;
  try {
    (() => {
    const balk = document.querySelector('[data-eerste-bezoek]');
    if (!balk) return;
    if (document.querySelector('[data-sticky-hulp], .lp-sticky, [data-sticky-koop]')) return;
    const SLEUTEL = 'sm_hulp_eerste_bezoek';
    /* Lezen lukt niet (privévenster, geblokkeerde opslag): dan geen balk. Liever
       nooit een balk dan op elke pagina opnieuw een balk. */
    try {
      if (localStorage.getItem(SLEUTEL)) return;
    } catch {
      return;
    }
    let getoond = false;
    const toon = () => {
      if (getoond) return;
      getoond = true;
      window.removeEventListener('scroll', opScroll);
      balk.hidden = false;
      try {
        localStorage.setItem(SLEUTEL, '1');
      } catch {}
    };
    const opScroll = () => {
      const max = document.documentElement.scrollHeight - innerHeight;
      if (max > 0 && scrollY / max >= 0.4) toon();
    };
    window.addEventListener('scroll', opScroll, { passive: true });
    setTimeout(toon, 20000);
    balk.querySelector('[data-eerste-bezoek-sluit]').addEventListener('click', () => {
      balk.hidden = true;
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sm-filterbalk"] && !Shopify.designMode) return;
  try {
    // Verrijking, geen voorwaarde: zonder JS submit de bezoeker met de knop uit
  // <noscript>. Hier vervangt een wijziging die klik.
  //
  // Gedelegeerd op document, niet per formulier: dit blok draait één keer per
  // paginalading, terwijl de theme-editor de sectie opnieuw rendert bij elke
  // instelling. Een direct gebonden listener is daarna weg en de balk doet dan
  // niets meer — de noscript-knop staat er niet als JS aan staat.
  // In de sheet (variant `nieuw`) niet: daar kiest de bezoeker meerdere dingen
  // en verstuurt hij met de knop onderin. Elke tik een herlaad sloot de sheet.
  document.addEventListener('change', (e) => {
    const form = e.target.closest('[data-fbar-form]');
    if (form && !form.closest('[data-fbar-sheet]')) form.submit();
  });

  // Variant `nieuw`: het formulier naar de sheet verhuizen, en openen/sluiten.
  // Alleen als de variant echt `nieuw` is — anders blijft alles waar het staat.
  // Alleen op mobiel (zelfde grens als de CSS); wie het venster verbreedt,
  // krijgt het formulier terug in de balk, anders staan er op desktop geen
  // facetten meer.
  const fbarMobiel = window.matchMedia('(max-width: 620px)');
  const fbarSheet = (root) => {
    if (document.documentElement.dataset.collVariant !== 'nieuw') return;
    const sheet = root.querySelector('[data-fbar-sheet]');
    const bar = sheet?.closest('.fbar');
    const slot = sheet?.querySelector('[data-fbar-sheet-slot]');
    if (!sheet || !bar || !slot) return;
    const form = bar.querySelector('[data-fbar-form]');
    if (!form) return;
    if (fbarMobiel.matches) slot.append(form);
    else {
      if (sheet.open) sheet.close();
      bar.insertBefore(form, sheet);
    }
    // Het gekozen doel in beeld schuiven: met Kracht & Herstel aan stond die
    // chip op x=664, buiten de strip (critique 12-10). Rekenwerk op scrollLeft
    // en geen scrollIntoView: dat schuift ook de pagina zelf.
    const strip = bar.querySelector('.fbar-chips');
    const chip = strip?.querySelector('[aria-current][data-goal]');
    if (strip && chip) strip.scrollLeft = chip.offsetLeft - strip.offsetLeft - (strip.clientWidth - chip.offsetWidth) / 2;
  };
  fbarSheet(document);
  fbarMobiel.addEventListener('change', () => fbarSheet(document));
  document.addEventListener('shopify:section:load', (e) => fbarSheet(e.target));
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-fbar-open]');
    if (open) {
      const sheet = document.getElementById(open.getAttribute('aria-controls'));
      if (sheet?.showModal && !sheet.open) {
        sheet.showModal();
        // Het eerste facet staat open: één tik minder naar de eerste keuze.
        const eerste = sheet.querySelector('.fbar-facet');
        if (eerste && !sheet.querySelector('.fbar-facet[open]')) eerste.open = true;
      }
      return;
    }
    const sheet = e.target.closest('[data-fbar-sheet]');
    // "Wis {facet}" in de sheet: lokaal leegmaken in plaats van navigeren, anders
    // gaan de keuzes die nog niet toegepast zijn stil verloren (Codex 12-10).
    const wisFacet = sheet && e.target.closest('.fbar-pop-clear');
    if (wisFacet) {
      e.preventDefault();
      wisFacet.closest('.fbar-facet')?.querySelectorAll('input').forEach((i) => {
        if (i.type === 'checkbox') i.checked = false;
        else i.value = '';
      });
      return;
    }
    // Klik op de backdrop = op het dialog-element zelf, buiten zijn inhoud.
    if (sheet && (e.target === sheet || e.target.closest('[data-fbar-sluit]'))) sheet.close();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sm-keuzepakket-kaal"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (e) => {
    const link = e.target.closest('[data-kaal-key]');
    if (!link) return;
    e.preventDefault();
    let weg = false;
    try {
      const r = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: link.dataset.kaalKey, quantity: 0 }),
      });
      weg = r.ok;
    } catch (err) {}
    if (weg) {
      location.href = link.dataset.kaalUrl;
      return;
    }
    link.closest('.cd-regel-kaal').textContent =
      link.dataset.kaalMelding;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sm-pakket-box"] && !Shopify.designMode) return;
  try {
    // Meertalig (10-2026): dit blok rendert geen Liquid, dus de teksten komen uit
  // window.smT (sleutels sm.js.sm_pakket_box.*). [naam] is een invulplek.
  const psT = (sleutel, nl, vars = {}) =>
    Object.entries(vars).reduce(
      (tekst, [naam, waarde]) => tekst.split(`[${naam}]`).join(waarde),
      window.smT ? window.smT(`sm.js.sm_pakket_box.${sleutel}`, nl) : nl,
    );

  class PakketSlots {
    constructor(root) {
      this.root = root;
      this.paneel = root.querySelector('[data-ps-paneel]');
      this.opties = Array.from(root.querySelectorAll('[data-ps-optie]'));
      this.status = root.querySelector('[data-ps-status]');
      this.slots = Array.from(root.querySelectorAll('[data-ps-slot]'));
      this.actief = null;

      root.querySelector('[data-ps-sluit]').addEventListener('click', () => this.paneel.close());
      this.paneel.addEventListener('click', (e) => {
        if (e.target === this.paneel) this.paneel.close();
      });

      this.opties.forEach((rij) => this.bindOptie(rij));

      // Terugfocus. Esc en de sluitknop laten de browser de focus terugzetten
      // op wat ervóór focus had — maar wie op de kaart tikte (geen focusbaar
      // element) belandt dan op <body>. De ruilknop van het slot is altijd de
      // juiste plek om terug te komen.
      this.paneel.addEventListener('close', () => {
        this.actief?.querySelector('[data-ps-ruil]')?.focus();
      });

      this.wachtOpApp();
    }

    // ⚠ ELKE keer opnieuw opzoeken, nooit een select-node bewaren. Gemeten
    // 04-09-2026: de app vervangt zijn `properties[Meal N]`-selects kort na de
    // eerste render. Een bewaarde referentie wijst daarna naar een losgekoppelde
    // node — en dan is de fout precies de gevaarlijkste soort: het ruilpaneel
    // werkt, de kaart wisselt zichtbaar, maar `sel.value` landt op een node die
    // niet meer in het formulier zit. De klant ziet zijn keuze en de keuken
    // krijgt de oude maaltijd. Dit is de reden dat er geen Map met selects is.
    selectVan(naam) {
      return document.querySelector(`select[name="properties[${naam}]"]`);
    }

    // De app injecteert de selects uit een JS-string na zijn eigen script. Er is
    // geen event en geen belofte waarop je kunt wachten, dus we kijken tot ze er
    // zijn. Achttien seconden is ruim boven de traagste meting en het stopt
    // vanzelf: eindeloos pollen op een pagina zonder app-embed kost accu.
    //
    // ⚠ `setTimeout` en nadrukkelijk GEEN `requestAnimationFrame`. Een tab die
    // niet zichtbaar is krijgt geen frames, dus een rAF-lus staat daar stil. Dat
    // treft niet alleen een meting: wie deze PDP in een nieuw tabblad opent en
    // pas later kijkt, zou een blok zien dat niet werkt. Een achtergrondtab
    // knijpt timers af tot ongeveer één per seconde, maar hij blijft lopen.
    wachtOpApp() {
      const deadline = Date.now() + 18000;
      const kijk = () => {
        const gevonden = this.slots.every((slot) => this.selectVan(slot.dataset.psSlot));

        // `every` op een lege lijst is `true`. Zonder deze toets zou een sectie
        // zonder slots zichzelf 'gekoppeld' melden.
        if (gevonden && this.slots.length > 0) {
          this.koppel();
        } else if (Date.now() < deadline) {
          setTimeout(kijk, 120);
        } else {
          // Geen selects: de kaarten blijven staan als presentatie van wat er in
          // de doos zit. De ruilknoppen blijven uit — ruilen zonder drager zou
          // een keuze tonen die de wagen nooit bereikt.
          this.status.textContent = psT(
            'status_no_swap',
            'De maaltijden staan klaar. Ruilen kan zodra de pagina volledig geladen is.',
          );
          this.status.classList.add('is-zichtbaar');
        }
      };
      kijk();
    }

    koppel() {
      this.slots.forEach((slot) => {
        const sel = this.selectVan(slot.dataset.psSlot);
        if (!sel) return;
        // De select is de waarheid: wat de server op de kaart zette was een
        // plausibele start, geen meting.
        this.toon(slot, sel.value);

        // Een vast slot (één keuze) heeft geen knop — er valt niets te ruilen.
        const knop = slot.querySelector('[data-ps-ruil]');
        if (!knop) return;
        knop.disabled = false;
        knop.addEventListener('click', () => this.open(slot));

        // De hele kaart opent het paneel ook: wie op de foto tikt van een
        // maaltijd die hij niet lust, wil precies dit. De knop blijft de
        // toegankelijke ingang (focus, label); dit is de snelkoppeling.
        const kaart = slot.querySelector('[data-ps-kaart]');
        kaart.classList.add('is-klikbaar');
        kaart.addEventListener('click', (e) => {
          if (e.target.closest('[data-ps-ruil]')) return;
          this.open(slot);
        });
      });

      // Pas ná het vervangen van de selects door de app (zie `selectVan`): een
      // waarde die we eerder zetten, gooit die vervanging stil weg. Daarna de
      // kaarten nog één keer gelijktrekken met wat er écht in het formulier
      // staat — het formulier is de waarheid, nooit de kaart.
      setTimeout(() => {
        this.ontdubbel();
        setTimeout(() => this.synchroniseer(), 900);
      }, 1500);

      // ⚠ Gedelegeerd op `document` en niet per select. Een listener op de node
      // zelf sterft zodra de app die node vervangt; `change` bubbelt, dus deze
      // overleeft elke herrender. Hij houdt de kaart gelijk aan het formulier —
      // ook wanneer de app een waarde zelf terugzet.
      document.addEventListener('change', (e) => {
        const naam = e.target?.name;
        if (!naam || !naam.startsWith('properties[')) return;
        const slot = this.slots.find((s) => `properties[${s.dataset.psSlot}]` === naam);
        if (slot) this.toon(slot, e.target.value);
      });

      // ⚠ Verbergen via een klasse en CSS, niet via inline styles op de select.
      // Inline styles verdwijnen mét de node zodra de app herrendert; een
      // klasse op <html> blijft staan en de regel pakt de nieuwe container ook.
      document.documentElement.classList.add('ps-app-verborgen');

      this.status.textContent = psT(
        'status_swap',
        'De maaltijden staan klaar — je hoeft niets te kiezen. Liever iets anders? Ruil per maaltijd.',
      );
    }

    // Staat er een uitverkochte maaltijd voorgeselecteerd, of komt een maaltijd
    // twee keer voor, dan krijgt dat slot de eerste leverbare maaltijd die nog
    // niet in de box zit.
    //
    // Is de eerste keuze van een slot uitverkocht, dan zet de app `selected` op
    // de eerstvolgende leverbare optie — en die is bij een geroteerde pool
    // precies de start van het vólgende slot. Gemeten 29-09 op het 570 g-pakket:
    // Kip Piri Piri uitverkocht → twee keer Beef Rendang in een box van tien,
    // zonder dat iemand dat koos. Hier schuift zo'n dubbel door naar de eerste
    // leverbare maaltijd die nog niet in de box zit. Alleen bij een échte
    // dubbeling: een klant die zelf twee keer hetzelfde kiest, raakt dit niet,
    // want dit draait één keer bij het koppelen.
    // Uitverkocht volgens de storefront (`product.available`, server-side op de
    // optierij gezet). De app zet een uitverkochte optie niet altijd op
    // `disabled` — gemeten 29-09: op 570 g wel, op 350 g niet — dus dit is de
    // tweede bron naast `option.disabled`.
    // ⚠ Matchen op `data-match` (de select-waarde, altijd de Nederlandse titel),
    // nooit op `data-titel` (de weergave, in het Engels vertaald). Anders vindt
    // een Engelse bezoeker geen enkele rij en valt elke kaart terug op kale tekst.
    rijVan(waarde) {
      return this.opties.find((o) => o.dataset.match === waarde);
    }

    // De weergavenaam bij een select-waarde: vertaald als de rij er is.
    naamVan(waarde) {
      return this.rijVan(waarde)?.dataset.titel || waarde;
    }

    uitverkocht(waarde) {
      return this.opties.some((o) => o.dataset.match === waarde && o.dataset.uitverkocht === '1');
    }

    ontdubbel() {
      // Alles wat nu in de box zit telt als bezet, ook wat later in de rij
      // staat — anders schuift één dubbel door de hele rij heen.
      const inBox = new Set(
        this.slots.map((s) => this.selectVan(s.dataset.psSlot)?.value).filter(Boolean)
      );
      const gezien = new Set();
      this.slots.forEach((slot) => {
        if (slot.hasAttribute('data-ps-vast')) return;
        const sel = this.selectVan(slot.dataset.psSlot);
        if (!sel) return;
        if (!gezien.has(sel.value) && !this.uitverkocht(sel.value)) {
          gezien.add(sel.value);
          return;
        }
        const vrij = Array.from(sel.options).find(
          (o) => o.value && !o.disabled && !inBox.has(o.value) && !this.uitverkocht(o.value)
        );
        if (!vrij) return;
        sel.value = vrij.value;
        sel.dispatchEvent(new Event('input', { bubbles: true }));
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        this.toon(slot, vrij.value);
        gezien.add(vrij.value);
        inBox.add(vrij.value);
      });
    }

    synchroniseer() {
      this.slots.forEach((slot) => {
        const sel = this.selectVan(slot.dataset.psSlot);
        if (sel) this.toon(slot, sel.value);
      });
    }

    // Een titel die alleen in de select bestaat en niet in `bundled_variants`.
    // Dat komt voor: een keuzeslot kan een gerecht aanbieden dat niet als
    // bundelcomponent geregistreerd staat. Er is dan geen foto en geen macro,
    // dus dit vlak draagt alleen de naam — en `textContent`, niet `innerHTML`,
    // want deze tekst komt uit app-data.
    kaalVlak(titel) {
      // Zelfde opbouw als `sm-gerecht-vlak` (`.gv__body` > `.gv__titel`), anders
      // mist de naam de kaartpadding.
      const body = document.createElement('span');
      body.className = 'gv__body';
      const span = document.createElement('span');
      span.className = 'gv__titel';
      span.textContent = titel;
      body.appendChild(span);
      return body;
    }

    toon(slot, waarde) {
      if (!waarde) return;
      const bron = this.rijVan(waarde);
      const titel = this.naamVan(waarde);
      const kaart = slot.querySelector('[data-ps-kaart]');
      const body = kaart.querySelector('[data-ps-body]');
      kaart.dataset.titel = titel;

      if (bron) {
        body.innerHTML = bron.querySelector('.ps__body').innerHTML;
      } else {
        // ⚠ Zonder deze tak blijft de kaart de VORIGE maaltijd tonen terwijl
        // `data-titel` al de nieuwe draagt. Dat is de gevaarlijkste stand die
        // dit blok kan hebben: het scherm noemt een gerecht dat niet in de doos
        // zit, en niets meldt het.
        body.replaceChildren(this.kaalVlak(titel));
      }

      const knop = slot.querySelector('[data-ps-ruil]');
      if (!knop) return;
      knop.setAttribute(
        'aria-label',
        psT('swap_aria', 'Ruil [plek]: [titel]', { plek: this.plekVan(slot, 'meal_n'), titel }),
      );
    }

    // De Kies-knop is de toegankelijke ingang; een tik op de foto of de naam
    // doet hetzelfde, want daar tikt een duim op een telefoon het eerst.
    bindOptie(rij) {
      // Open voedingswaarde neemt de hele rij (zie de CSS): de rij verspringt
      // dan, dus zet hem weer in beeld.
      rij.querySelector('.ps__info')?.addEventListener('toggle', (e) => {
        if (e.target.open) rij.scrollIntoView({ block: 'nearest' });
      });
      const knop = rij.querySelector('[data-ps-kies]');
      knop.addEventListener('click', () => this.kies(rij.dataset.match));
      rij.querySelector('[data-ps-optiebody]').addEventListener('click', () => {
        if (!knop.disabled) this.kies(rij.dataset.match);
      });
    }

    // "plek 3" voor een maaltijd, "gratis ontbijt" voor een gratis slot — de
    // nummers van de gratis kaarten zijn verborgen, dus die noemen we bij naam.
    // `soort` 'meal_n' geeft "maaltijd 3" (het ruillabel).
    plekVan(slot, soort = 'spot_n') {
      if (slot.classList.contains('ps__slot--gratis')) return slot.dataset.psSlot.toLowerCase();
      const n = slot.querySelector('.ps__nr').textContent.trim();
      return soort === 'meal_n' ? psT('meal_n', 'maaltijd [n]', { n }) : psT('spot_n', 'plek [n]', { n });
    }

    open(slot) {
      const sel = this.selectVan(slot.dataset.psSlot);
      if (!sel) return;
      this.actief = slot;

      // Wat dit slot accepteert, staat in de select en nergens anders. Een in
      // Liquid nagebouwde pool loopt uit de pas zodra de app-configuratie wijzigt.
      //
      // ⚠ Ook de `disabled` opties. Tot 06-10 filterde deze regel ze weg, en
      // de app zet een uitverkochte optie op `disabled` (gemeten 06-10 op 570 g:
      // Kip Piri Piri) — dus een uitverkocht gerecht verdween zonder uitleg uit
      // het paneel. Nu staat hij er, achteraan, als "Uitverkocht".
      const waarden = Array.from(sel.options).filter((o) => o.value);
      const toegestaan = new Set(waarden.map((o) => o.value));
      const appUit = new Set(waarden.filter((o) => o.disabled).map((o) => o.value));
      const huidig = sel.value;

      // Wat de select aanbiedt maar `bundled_variants` niet kent, bestaat nog
      // niet als rij. Zonder deze aanvulling is zo'n gerecht onbereikbaar: het
      // paneel toont hem niet, dus de klant kan hem niet kiezen — ook al staat
      // hij gewoon in het formulier.
      [...toegestaan]
        .filter((t) => !this.rijVan(t))
        .forEach((waarde) => this.voegOptieToe(waarde));

      this.opties.forEach((rij) => {
        const titel = rij.dataset.titel;
        const waarde = rij.dataset.match;
        rij.hidden = !toegestaan.has(waarde);
        const op = rij.dataset.uitverkocht === '1' || appUit.has(waarde);
        const isHuidig = waarde === huidig;
        rij.classList.toggle('is-uitverkocht', op && !isHuidig);
        rij.classList.toggle('is-huidig', isHuidig);

        const knop = rij.querySelector('[data-ps-kies]');
        knop.disabled = op || isHuidig;
        knop.textContent = isHuidig
          ? psT('chosen', 'Gekozen')
          : op
            ? psT('sold_out', 'Uitverkocht')
            : psT('choose', 'Kies');
        knop.setAttribute('aria-label', `${knop.textContent}: ${titel}`);

        // Geen "Zit al in je box" meer (stond er tot 06-10): in een box van
        // tien uit een pool van dertien droeg tien van de dertien opties dat
        // label, en dan zegt het niets meer. Alleen wat telt: dit zit nu op
        // déze plek, en dit kan niet.
        const label = rij.querySelector('[data-ps-label]');
        label.textContent = isHuidig ? psT('here_now', 'Nu op deze plek') : op ? psT('sold_out', 'Uitverkocht') : '';
        label.hidden = !label.textContent;
      });

      const gratis = slot.classList.contains('ps__slot--gratis');
      this.root.querySelector('[data-ps-paneel-titel]').textContent = gratis
        ? psT('choose_your', 'Kies je [plek]', { plek: this.plekVan(slot) })
        : psT('choose_other_for', 'Kies een andere maaltijd voor [plek]', { plek: this.plekVan(slot) });
      // Elk paneel opent met alles dichtgeklapt: een open voedingswaarde van het
      // vorige slot neemt anders meteen een hele rij in.
      this.root.querySelectorAll('.ps__info[open]').forEach((d) => { d.open = false; });
      this.root.querySelector('[data-ps-opties]').scrollTop = 0;
      this.paneel.showModal();
    }

    voegOptieToe(titel) {
      const rij = document.createElement('li');
      rij.className = 'ps__optie-rij';
      rij.dataset.psOptie = '';
      rij.dataset.titel = titel;
      rij.dataset.match = titel;
      rij.hidden = true;

      const label = document.createElement('span');
      label.className = 'ps__optie-label';
      label.dataset.psLabel = '';
      label.hidden = true;

      const body = document.createElement('div');
      body.className = 'ps__optie-body ps__body';
      body.dataset.psOptiebody = '';
      body.appendChild(this.kaalVlak(titel));

      const knop = document.createElement('button');
      knop.type = 'button';
      knop.className = 'ps__kies';
      knop.dataset.psKies = '';
      knop.textContent = psT('choose', 'Kies');

      rij.append(label, body, knop);
      this.root.querySelector('[data-ps-opties]').appendChild(rij);
      this.opties.push(rij);
      this.bindOptie(rij);
      return rij;
    }

    kies(waarde) {
      const slot = this.actief;
      if (!slot) return;
      const sel = this.selectVan(slot.dataset.psSlot);
      if (!sel) return;

      sel.value = waarde;
      // De app luistert op change voor prijs- en voorraadlogica; input erbij
      // omdat niet elke luisteraar hetzelfde event kiest.
      sel.dispatchEvent(new Event('input', { bubbles: true }));
      sel.dispatchEvent(new Event('change', { bubbles: true }));

      this.toon(slot, waarde);
      this.paneel.close(); // de close-listener zet de focus terug op de ruilknop
      this.status.textContent = psT('swapped', 'Geruild: [plek] is nu [titel].', {
        plek: this.plekVan(slot),
        titel: this.naamVan(waarde),
      });
    }
  }

  // Shopify bundelt elke een javascript-blok in compiled_assets/scripts.js en laadt
  // die bundel vóór de sectie-HTML. Zonder deze wacht is `[data-ps]` op
  // uitvoeringstijd leeg, wordt er geen instantie gemaakt, en blijft het blok
  // staan als dode presentatie — zonder fout in de console, want een lege
  // NodeList itereren is geldig.
  const start = () => document.querySelectorAll('[data-ps]').forEach((el) => new PakketSlots(el));
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sm-pakket-galerij"] && !Shopify.designMode) return;
  try {
    /* Podium + paneel. Drie handelingen, geen state buiten de DOM:
     wissel het podium, open het paneel, sluit het paneel.

     Altijd `showModal()`, ook op desktop. De niet-modale variant stond hier
     eerst: die blijft in de normale flow en kon dus absoluut binnen het podium
     liggen, doorschijnend over het gerecht. Alleen staan de tegels ónder het
     podium — op 1728px van y=1084 tot 2076, terwijl het podium op 962 eindigt —
     dus bij een tik was het podium al uit beeld en opende het paneel buiten het
     scherm. Modal geeft daarnaast backdrop, focusslot en Escape van de browser
     zelf; dat scheelt precies de code die hier eerst stond en die op één punt
     al fout was. */
  (function () {
    var wortels = document.querySelectorAll('[data-pgal]');
    if (!wortels.length) return;

    wortels.forEach(function (wortel) {
      var stage = wortel.querySelector('[data-pgal-stage]');
      var stageWrap = wortel.querySelector('[data-pgal-stage-wrap]');
      var open = null;
      var opener = null;

      /* Geeft terug of deze knop het podium ook echt vertegenwoordigt. Dat is
         niet hetzelfde als "er wisselde iets": staat het beeld er al, dan is de
         knop nog steeds de huidige. Alleen een knop zónder bron is dat niet, en
         die mag zich dus ook niet zo laten markeren. Zie `markeer` hieronder. */
      function zet(knop) {
        if (!stage) return false;
        var src = knop.getAttribute('data-pgal-src');
        if (!src) return false;
        if (stage.getAttribute('src') === src) return true;
        /* Uitfaden, dan pas de bron wisselen: zonder de vertraging staat het
           nieuwe beeld er al voor de overgang begint en zie je een harde knip.

           ⚠ Hier stond `decode()`, omdat die ook op tekenklaar wacht. Alleen:
           op een `Image` die niet in het document hangt lost die belofte in
           Chrome nóóit op — gemeten 09-09-2026 op de preview, 3294ms na de klik
           nog steeds pending terwijl `complete` true was en `naturalWidth` 1620.
           En omdat `Promise.all` op beide wacht, bleef het podium in
           `is-wisselend` staan en wisselde het beeld niet: een tik op een
           gerecht deed visueel niets. `load` vuurt op zo'n losse Image wél —
           dat is de gewone voorlaad-truc — en `complete` vangt de cache-treffer
           af, die anders geen event meer geeft. */
        var vers = new Image();
        var srcset = knop.getAttribute('data-pgal-srcset');
        if (srcset) vers.srcset = srcset;
        vers.src = src;
        stageWrap.classList.add('is-wisselend');
        var klaar = new Promise(function (klaarIs) {
          if (vers.complete) return klaarIs();
          vers.addEventListener('load', klaarIs, { once: true });
          /* Ook bij een fout doorgaan: een podium dat blijft hangen is erger dan
             een beeld dat de browser zelf als gebroken toont. */
          vers.addEventListener('error', klaarIs, { once: true });
        });
        Promise.all([klaar, new Promise(function (r) { setTimeout(r, 180); })]).then(function () {
          stage.src = src;
          if (srcset) stage.srcset = srcset;
          stage.alt = knop.getAttribute('data-pgal-alt') || '';
          stageWrap.classList.remove('is-wisselend');
        });
        return true;
      }

      /* ⚠ Alleen aanroepen als `zet` true gaf. Met de instelling "hoofdbeeld
         wisselt met het gerecht" úít — en dat is de standaard — draagt een
         gerechttegel geen `data-pgal-src`, dus het podium blijft het pakketbeeld
         tonen. Werd `markeer` dan tóch gedraaid, dan kreeg de aangetikte tegel
         `aria-current="true"` plus de omlijning, en werd élk stripbeeld op
         `aria-pressed="false"` gezet: het scherm én de schermlezer meldden een
         keuze die het podium niet laat zien. Gemeten op live 10-09-2026 (nul
         tegels met bron, podiumbeeld ongewijzigd, tóch één aria-current).
         Codex-review 10-09-2026. */
      function markeer(knop) {
        wortel.querySelectorAll('.pgal-tegel[aria-current]').forEach(function (t) {
          t.removeAttribute('aria-current');
        });
        wortel.querySelectorAll('[data-pgal-foto]').forEach(function (d) {
          d.setAttribute('aria-pressed', String(d === knop));
        });
        if (knop.classList.contains('pgal-tegel')) knop.setAttribute('aria-current', 'true');
      }

      wortel.addEventListener('click', function (e) {
        var foto = e.target.closest('[data-pgal-foto]');
        if (foto && wortel.contains(foto)) {
          if (open) open.close();
          if (zet(foto)) markeer(foto);
          return;
        }

        var tegel = e.target.closest('[data-pgal-open]');
        if (tegel && wortel.contains(tegel)) {
          var dlg = wortel.querySelector('#' + CSS.escape(tegel.getAttribute('data-pgal-open')));
          if (!dlg) return;
          if (open) open.close();
          if (zet(tegel)) markeer(tegel);
          opener = tegel;
          open = dlg;
          dlg.showModal();
          var sluitknop = dlg.querySelector('[data-pgal-close]');
          if (sluitknop) sluitknop.focus();
          return;
        }

        if (e.target.closest('[data-pgal-close]')) {
          if (open) open.close();
          return;
        }

        /* Klik-weg. Een klik op de backdrop van een modale dialoog landt op de
           dialoog zelf; alles binnenín heeft een ander doel. */
        if (open && e.target === open) open.close();
      });

      /* Eén plek waar het opruimen gebeurt, en dat is `close` — niet de
         sluitfunctie. De browser sluit deze dialoog namelijk ook zelf, bij
         Escape, en dan komt er geen klik langs. Zou het herstellen van de focus
         in een eigen functie staan, dan sprong de focus na Escape naar het begin
         van de pagina. */
      wortel.addEventListener('close', function (e) {
        if (e.target !== open) return;
        open = null;
        if (opener) opener.focus();
        opener = null;
      }, true);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sm-pdp-galerij"] && !Shopify.designMode) return;
  try {
    /* Swiperij (try-out): knoppen schuiven één foto, en verdwijnen aan het begin
     en eind van de rij. Eén handler op document, zoals sm-products. */
  (() => {
    const zet = (rij) => {
      const strook = rij.closest('.pdp-strook');
      const eind = rij.scrollWidth - rij.clientWidth - 2;
      strook.querySelector('[data-strook-schuif="-1"]').disabled = rij.scrollLeft <= 2;
      strook.querySelector('[data-strook-schuif="1"]').disabled = rij.scrollLeft >= eind;
    };
    document.addEventListener('click', (e) => {
      const knop = e.target.closest('[data-strook-schuif]');
      if (!knop) return;
      const rij = knop.closest('.pdp-strook')?.querySelector('.pdp-strook__rij');
      if (!rij) return;
      const tegel = rij.firstElementChild;
      const stap = tegel ? tegel.getBoundingClientRect().width + parseFloat(getComputedStyle(rij).columnGap || 0) : rij.clientWidth * 0.8;
      const zacht = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      rij.scrollBy({ left: Number(knop.dataset.strookSchuif) * stap, behavior: zacht });
    });
    document.addEventListener('scroll', (e) => {
      if (e.target instanceof Element && e.target.matches('.pdp-strook__rij')) zet(e.target);
    }, true);
    const start = () => document.querySelectorAll('.pdp-strook__rij').forEach(zet);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sm-product-card"] && !Shopify.designMode) return;
  try {
    // "Bekijk inhoud" op een pakketkaart. Haalt `sm-bundel-quickview` op voor dát
  // pakket en toont hem in één gedeelde <dialog>, in de vorm van het gerecht-
  // venster uit `sm-bundel-inhoud` (bottom sheet op een telefoon). Het attribuut
  // `data-sm-bundel-dialog` geeft hem ook de backdrop-klik van dat snippet.
  // Lukt het ophalen niet, dan gaat de klant gewoon naar het pakket: dat is
  // waar de link zonder JS ook heen gaat.
  document.addEventListener('click', async (e) => {
    const link = e.target.closest('[data-sm-inhoud]')
    if (!link || e.metaKey || e.ctrlKey || e.shiftKey) return
    e.preventDefault()

    let dlg = document.querySelector('[data-sm-inhoud-dialog]')
    if (!dlg) {
      dlg = document.createElement('dialog')
      dlg.className = 'sm-bundel__dialog qv-dialog'
      dlg.setAttribute('data-sm-inhoud-dialog', '')
      dlg.setAttribute('data-sm-bundel-dialog', '')
      dlg.setAttribute('scroll-lock', '')
      dlg.setAttribute('aria-label', link.dataset.labelDialoog || 'Inhoud van dit pakket')
      document.body.append(dlg)
    }
    const url = link.getAttribute('href')
    dlg.dataset.url = url
    dlg.innerHTML =
      '<form method="dialog" class="sm-bundel__sluitrij"><button class="sm-bundel__sluit" value="dicht" aria-label="' + (link.dataset.labelSluiten || 'Sluiten') + '">&times;</button></form>' +
      '<div class="qv qv--laden" aria-busy="true"><p>' + (link.dataset.labelLaden || 'Even laden…') + '</p></div>'
    if (!dlg.open) dlg.showModal()

    try {
      const r = await fetch(url + (url.includes('?') ? '&' : '?') + 'section_id=sm-bundel-quickview')
      if (!r.ok) throw new Error(r.status)
      const html = await r.text()
      // Een tweede klik op een andere kaart kan deze inhaal: dan niet overschrijven.
      if (dlg.dataset.url !== url) return
      dlg.querySelector('.qv').outerHTML = html
    } catch {
      location.href = url
    }
  })

  // Toevoegen vanuit het venster: de drawer-JS vangt het formulier zelf op
  // (gedelegeerd op document, `sm-cart-drawer`). Het venster gaat dicht, zodat
  // de wagen-la niet achter een tweede modaal opent maar gewoon in beeld komt.
  document.addEventListener('submit', (e) => {
    // Alleen een wagenformulier. De sluitknop van een gerechtpaneel is óók een
    // formulier (method="dialog") binnen dit venster, en die moet alleen het
    // paneel sluiten.
    const form = e.target
    if (!form.action || !form.action.includes('/cart/add')) return
    const dlg = form.closest('[data-sm-inhoud-dialog]')
    if (dlg && dlg.open) dlg.close()
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sm-sticky-hulp"] && !Shopify.designMode) return;
  try {
    /* Rect-meting op scroll, geen IntersectionObserver — om de reden die in
     sm-sticky-koop staat: die observer viel op de pakket-PDP stil zonder
     aanwijsbare oorzaak, en een getal dat je uitrekent op het moment dat je het
     nodig hebt kan niet stil verlopen. Eén meting per animatieframe waarin
     gescrold is. */
  (() => {
    let gepland = false;
    const meet = () => {
      gepland = false;
      const balk = document.querySelector('[data-sticky-hulp]');
      if (!balk) return;
      const anker = document.querySelector(balk.dataset.anker);
      /* Geen anker: geen balk. Het `hidden` gaat pas af als er iets te meten is,
         zodat de balk zonder JS ook nooit half zichtbaar blijft hangen. */
      if (!anker) return;
      balk.hidden = false;
      const koop = document.querySelector('[data-sticky-koop].on');
      balk.classList.toggle('on', anker.getBoundingClientRect().bottom < 0 && !koop);
    };
    const plan = () => {
      if (gepland) return;
      gepland = true;
      requestAnimationFrame(meet);
    };
    addEventListener('scroll', plan, { passive: true });
    addEventListener('resize', plan, { passive: true });
    addEventListener('load', plan);
    document.addEventListener('shopify:section:load', plan);
    meet();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sm-sticky-koop"] && !Shopify.designMode) return;
  try {
    /* De balk verschijnt zodra het koopblok naar BÓVEN uit beeld is — niet wanneer
     het er nog ónder staat, want bij het laden van de pagina is het koopblok ook
     "niet zichtbaar" en dan hoort er geen balk te staan.

     ⚠ Een rect-meting op scroll, en géén IntersectionObserver, terwijl het
     ontwerp (Pdp.jsx) die wél gebruikt. Gemeten op de pakket-PDP in de preview
     van 28-08: de observer bleef daar dood. Hij werd aangemaakt, kreeg zijn
     anker en zijn eerste callback, en reageerde daarna nergens meer op — terwijl
     een handmatige tweede init hem meteen liet werken, en een verse observer met
     exact dezelfde parameters vanuit de console óók. Nagegaan en uitgesloten:
     het snippet stond in `data-snippets` (de bundel-guard liet dus door), er was
     precies één balk en één anker, en een MutationObserver op #sm-main zag over
     vier seconden geen enkele vervanging van beide knopen. Op de losse-maaltijd-
     PDP werkte dezelfde code wél. Het verschil is niet gevonden; wat vaststaat is
     dat de uitkomst per pagina verschilde.

     Een rect-meting heeft dat probleem niet: er is geen registratie die stil kan
     verlopen, alleen een getal dat je uitrekent op het moment dat je het nodig
     hebt. Kosten: één `getBoundingClientRect()` per animatieframe waarin er
     gescrold is, achter een rAF-slot en passieve listeners. Dat is de ruil
     waarvoor je een elegantere API laat staan — de goedkopere oplossing die stil
     faalt, is de dure.

     De aanleiding om hier überhaupt naar te kijken was de Codex-review van
     28-08: die wees erop dat de pakket-PDP zijn stappen 1-3 afhandelt met
     `hoofd.innerHTML = …` (`wissel()` in sm-pakket), waardoor deze balk — die
     binnen #sm-main staat — door een verse kopie vervangen wordt. Vandaar het
     `sm:hoofd-vervangen`-signaal en de gedelegeerde submit-handler hieronder:
     beide overleven zo'n vervanging. */
  (() => {
    let gepland = false;

    const meet = () => {
      gepland = false;
      const balk = document.querySelector('[data-sticky-koop]');
      if (!balk) return;
      const anker = document.querySelector(balk.dataset.anker);
      /* Geen anker: de balk blijft weg. Liever geen balk dan een balk die nooit
         meer weggaat. Het `hidden`-attribuut staat in de markup en gaat er hier
         af, zodat de balk zonder JS ook niet half zichtbaar blijft hangen. */
      if (!anker) return;
      balk.hidden = false;
      /* ⚠ De balk stáát, altijd — besluit Joey 04-09-2026. Tot dan kwam hij pas
         als het koopblok naar boven uit beeld was (gemeten drempel op de
         pakket-PDP: scrollY 640), en dat betekende dat de eerste schermvulling
         van elke productpagina géén koopknop droeg, terwijl kopen de enige
         handeling is die die pagina vraagt.

         Het anker verdwijnt hiermee niet uit de code, en dat is opzet: het is de
         bron voor variant en aantal in de submit-handler hieronder, en de
         null-check erboven is precies waarom er géén balk verschijnt op een
         pagina die er geen heeft.

         `data-anker-vroeg` is hierdoor ongebruikt. Het attribuut blijft in de
         markup staan, zodat terugdraaien één regel is: vervang deze regel door
         de `toggle` op `trigger.getBoundingClientRect().bottom < 80`.

         ⚠ Eén uitzondering op "altijd", en die is geen verwatering van het
         besluit maar de voorwaarde ervoor: staat het échte koopblok in beeld,
         dan gaat de balk weg. Zonder die regel legt hij zich er bovenop. Gemeten
         04-09 op de losse-maaltijd-PDP bij 375x667: tussen scrollY 720 en 780
         bedekte de balk 49 van de 56px van de knop "In winkelwagen" — twee
         koopknoppen op elkaar, de echte vrijwel verstopt. De pagina compenseert
         de vaste balk namelijk nergens met ruimte onderaan (`padding-bottom: 0`
         op body én main), dus hij ligt over de inhoud.

         Het besluit blijft daarmee overeind: de eerste schermvulling van een
         productpagina draagt een koopknop. Alleen ís dat op het moment dat het
         koopblok zelf in beeld staat de échte knop, en dan is een tweede knop
         over de eerste heen geen extra kans maar een verstopte. */
      /* Meten aan de KNOP, niet aan het formulier eromheen. `.pakket-form` is
         een lang formulier: zodra de bovenkant ervan de onderrand van het scherm
         raakt zou de balk al verdwijnen, terwijl "In winkelwagen" nog ver onder
         de vouw ligt — dan is er even helemaal geen koopknop. Het anker blijft
         de bron voor variant en aantal in de submit-handler; alleen de meting
         zakt naar de knop. Codex-ronde 4 op 04-09. */
      /* Teller op de PDP (07-10): staat de maaltijd al in de wagen, dan is de
         submitknop verborgen (rect = 0 → "in beeld") en staat de stepper op zijn
         plek. Meet dus het eerste zichtbare koopelement. Codex 07-10. */
      const doel = [...anker.querySelectorAll('[type="submit"], [data-stepper]')]
        .find((el) => el.getClientRects().length > 0) || anker;
      const a = doel.getBoundingClientRect();
      /* Niet "raakt het scherm" maar "is hij te tikken, náást de balk". Twee
         eisen die elkaar bijten, en de volgorde waarin ze zijn opgelost staat
         hier omdat elke tussenvorm een echte storing was:

           · verdwijnt de balk bij het eerste pixeltje knop, dan is er even geen
             koopknop meer — de knop staat dan nog onder de vouw;
           · blijft hij tot de knop ergens in beeld is, dan ligt hij er middenin
             de overgang bovenop en is de echte knop half verstopt.

         Beide verdwijnen als je de knop meet in het gebied dat de balk vrijláát.
         Pas als daar 44px van de knop staat — of de hele knop, als die lager is —
         neemt hij het over. Tot dat moment blijft de balk, en dat hij dan een
         stukje van de knop bedekt is geen verlies: hij biedt dezelfde handeling
         op dezelfde plek. Codex-ronde 5 op 04-09. */
      const vrij = innerHeight - (balk.offsetHeight || 0);
      const zichtbaar = Math.min(a.bottom, vrij) - Math.max(a.top, 0);
      const inBeeld = zichtbaar >= Math.min(44, a.height);
      balk.classList.toggle('on', !inBeeld);
    };

    const plan = () => {
      if (gepland) return;
      gepland = true;
      requestAnimationFrame(meet);
    };

    /* Passief, want ze roepen nooit `preventDefault` aan en zonder die vlag houdt
       de browser het scrollen tegen tot hij dat weet.

       Deze twee stonden er tussen 04-09 en de review van diezelfde dag even niet:
       `meet` hing toen nergens meer aan, dus was een listener een `querySelector`
       per animatieframe met altijd hetzelfde antwoord. Nu de balk weer wijkt voor
       het koopblok in beeld, hangt hij wél aan de scrollpositie en moeten ze mee.

       Na een stap-1-t/m-3-wissel op de pakket-PDP staat er een verse balk in de
       DOM; die moet alsnog `hidden` af. Omdat deze opzet niets op een element
       registreert, volstaat één hermeting — er is geen observer die opnieuw
       gekoppeld moet worden. */
    addEventListener('scroll', plan, { passive: true });
    addEventListener('resize', plan, { passive: true });
    document.addEventListener('sm:hoofd-vervangen', plan);
    addEventListener('load', plan);
    meet();

    /* Keuzepakket (geen eigen formulier, zie de POORT in de doc): de échte
       submitknop in het anker indrukken. `.click()` op een submitknop loopt
       langs de native validatie en vuurt `submit` op het hoofdformulier, dus de
       drawer en Simple Bundles zien precies wat ze bij een gewone klik zien.

       Twee gevallen waarin de balk NIETS verstuurt maar de klant naar de keuze
       brengt: de knop staat uit (bv. de app is nog niet klaar), of het formulier
       is ongeldig (een lege `required` select). `checkValidity()` vóór de klik,
       want een native validatiemelding op een select die `sm-pakket-box` buiten
       beeld heeft gezet (1px, clip) toont nergens iets — dan scrollen we naar de
       slotkaart met dezelfde naam, en zetten we de focus op zijn ruilknop. */
    document.addEventListener('click', (e) => {
      const klik = e.target.closest && e.target.closest('[data-sticky-klik]');
      if (!klik) return;
      const balk = klik.closest('[data-sticky-koop]');
      const anker = balk && document.querySelector(balk.dataset.anker);
      if (!anker) return;
      const knop = anker.querySelector('[type="submit"]');
      const form = knop?.form || anker.closest('form') || anker.querySelector('form');
      const naarKeuze = (doel, focus) => {
        doel.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
        focus?.focus({ preventScroll: true });
      };
      if (!knop || knop.disabled || knop.getAttribute('aria-disabled') === 'true') {
        naarKeuze(anker, knop && !knop.disabled ? knop : null);
        return;
      }
      if (form && !form.checkValidity()) {
        const leeg = form.querySelector(':invalid:not(fieldset):not(form)');
        const naam = leeg?.name?.match(/^properties\[(.+)\]$/)?.[1];
        const slot = naam && document.querySelector(`[data-ps-slot="${CSS.escape(naam)}"]`);
        if (slot) {
          naarKeuze(slot, slot.querySelector('[data-ps-ruil]') || null);
        } else if (leeg && leeg.offsetParent && leeg.getBoundingClientRect().width > 1) {
          naarKeuze(leeg, leeg);
          leeg.reportValidity();
        } else {
          naarKeuze(anker, null);
        }
        return;
      }
      knop.click();
    });

    /* Variant én aantal uit het hoofdformulier meenemen, op `submit` en niet bij
       elke wijziging: de kiezer kan een input, een select of een stepper zijn, en
       alleen de stand op het moment van versturen telt. Gedelegeerd op `document`
       en niet op het formulier zelf, zodat een balk die na een wissel vervangen
       is meteen meedoet — dezelfde reden waarom de drawer zijn submit-handler
       daar heeft hangen. */
    document.addEventListener('submit', (e) => {
      const form = e.target.closest && e.target.closest('.sticky-form');
      if (!form) return;
      const balk = form.closest('[data-sticky-koop]');
      const anker = balk && document.querySelector(balk.dataset.anker);
      if (!anker) return;

      const qtyVeld = form.querySelector('[data-sticky-qty]');
      if (qtyVeld) {
        const bron = anker.querySelector('[name="quantity"]');
        const n = bron ? parseInt(bron.value, 10) : 1;
        qtyVeld.value = Number.isFinite(n) && n > 0 ? n : 1;
      }
      /* Alleen overnemen als het hoofdformulier écht een variant-id voert én die
         gevuld is; anders blijft de server-gerenderde waarde staan. Een leeg `id`
         maakt van /cart/add een 422, en dat is erger dan de terugval. */
      const idVeld = form.querySelector('[data-sticky-id]');
      if (idVeld) {
        const bronId = anker.querySelector('[name="id"]');
        if (bronId && bronId.value) idVeld.value = bronId.value;
      }
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sm-variant-wissel"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (e) => {
    const select = e.target;
    if (!select.matches || !select.matches('select[name="id"]')) return;
    const form = select.form;
    if (!form) return;
    const knop = form.querySelector('button[type="submit"].btn-atc');
    const inhoud = form.querySelector('template[data-atc-inhoud]');
    const optie = select.selectedOptions[0];
    if (!knop || !inhoud || !optie || optie.disabled) return;
    knop.innerHTML = inhoud.innerHTML;
    knop.disabled = false;
    inhoud.remove();
    const bis = form.parentElement && form.parentElement.querySelector('.bis');
    if (bis) bis.remove();
  });
  } catch(e) { console.error(e); }
})();

})();
